export async function checkToken(token) {
    const url = process.env.REACT_APP_COLLBACK_URL + `/api/client_task/survey/is_exists/?token=${token}`
    const response = await fetch(url)
    const json = await response.json()
    return response.ok ? json.detail : null
}